import React from "react";
import DecisionReviewSceneNav from "../../scoreboard-content/review/bottom/DecisionReviewSceneNav";
import { useStyles } from "../ScoreboardStyles.css";
const ScoreboardBottomReviewRunningTime = ({
    handleStep,
    activeStep,
    decisions,
    reviewEnd,
    sessionInfo,
    feedbackMode,
    endRun
}) => {
    const classes = useStyles();
    return (
        <div className={classes.scoreboardContainer}>
            <DecisionReviewSceneNav
                handleStep={handleStep}
                decisions={decisions}
                activeStep={activeStep}
                reviewEnd={feedbackMode === "standard" ? reviewEnd : true}
                sessionInfo={sessionInfo}
                feedbackMode={feedbackMode}
                endRun={endRun}
            />
        </div>
    );
};

export default ScoreboardBottomReviewRunningTime;
